<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'cli-areainteresse') {
            next({ name: 'cli-areainteresse-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'cli-areainteresse') {
            this.$router.push({ name: 'cli-areainteresse-list' });
        }
    },
};
</script>
